import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useMaxWidth,
} from '@grupoboticario/flora-react';
import { WhatsappLogoIcon } from '@grupoboticario/flora-react-icons';
import { user } from 'core';
import { addPageAction, getWhatsAppLink } from 'core/utilities';
import { useNavigate } from 'react-router';
import { Text, Link, ResponsiveFloraTypography } from 'ui/components/primitives';

import { Button, IRWhatsAppButton, ModalFooterMobile } from './ResaleIntention.styles';

const ResaleIntention = () => {
  const navigate = useNavigate();

  const homePath = '/departamentos';
  const isMobile = useMaxWidth('992px');

  const {
    data: { resellerId },
  } = user.hooks.useUser();

  const aggreeClick = () => {
    localStorage.setItem('is-ir', 'true');
    addPageAction('ir-click-understand', {
      resellerId,
    });

    navigate(homePath);
  };

  const openMoreInfos = () => {
    addPageAction('ir-click-more-info', {
      resellerId,
    });
  };

  return (
    <Modal open={true}>
      <ModalContent size="large" data-testid="resale-intention-modal">
        <ModalHeader>
          <ResponsiveFloraTypography as="h6" fontSize="subtitle" css={{ margin: 0 }}>
            Quase lá
          </ResponsiveFloraTypography>
        </ModalHeader>
        <ModalBody>
          <Text color="medium-light-1" variant="body-large-short">
            Para adicionar itens no carrinho, seu cadastrado precisa ser validado. Aguarde o contato
            da sua supervisora ou clique no botão abaixo para obter mais informações.
          </Text>
        </ModalBody>
        {isMobile ? (
          <ModalFooterMobile>
            <Button isFull={isMobile} onClick={aggreeClick}>
              Entendi
            </Button>
            <IRWhatsAppButton
              as={Link}
              to={getWhatsAppLink('41 8735-7095', isMobile)}
              target="_blank"
              rel="noopener noreferrer"
              onClick={openMoreInfos}
              variant="ghost"
              isFull={isMobile}
            >
              <WhatsappLogoIcon size={16} css={{ marginRight: '5px' }} />
              Ver mais informações
            </IRWhatsAppButton>
          </ModalFooterMobile>
        ) : (
          <ModalFooter>
            <IRWhatsAppButton
              as={Link}
              to={getWhatsAppLink('41 8735-7095', isMobile)}
              target="_blank"
              rel="noopener noreferrer"
              onClick={openMoreInfos}
              variant="ghost"
              isFull={isMobile}
            >
              <WhatsappLogoIcon size={16} css={{ marginRight: '5px' }} />
              Ver mais informações
            </IRWhatsAppButton>
            <Button isFull={isMobile} onClick={aggreeClick}>
              Entendi
            </Button>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default ResaleIntention;
